import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BookOpen, Bookmark, Clapperboard, Layers3 } from "lucide-react";
import OathboundExplore from "@/components/OathboundExplore/OathboundExplore";
import OathboundFrame from "@/components/OathboundFrame/OathboundFrame";
import OathboundPublications from "@/components/OathboundPublications/OathboundPublications";
import OathboundReviews from "@/components/OathboundReviews/OathboundReviews";
import SpecularButton from "@/components/SpecularButton/SpecularButton";
import "./OathboundLanding.css";

const editionFeatures = [
  { label: "6 × 9 in. premium hardcover", Icon: BookOpen },
  { label: "High-quality premium pages", Icon: Layers3 },
  {
    label: "45 minutes of exclusive audiovisual content",
    Icon: Clapperboard,
  },
  { label: "Complimentary bookmark included", Icon: Bookmark },
];

export default function OathboundLanding() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash !== "#purchase") return undefined;

    const animationFrame = window.requestAnimationFrame(() => {
      document.getElementById("purchase")?.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
        block: "start",
      });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [location.hash]);

  return (
    <main
      id="top"
      className="oathbound-page"
      aria-label="The Oath of the Unhuan"
      tabIndex="-1"
    >
      <OathboundFrame />

      <section
        id="purchase"
        className="oathbound-hero"
        aria-labelledby="oathbound-hero-title"
      >
        <h1 id="oathbound-hero-title" className="oathbound-sr-only">
          The Oath of the Unhuan
        </h1>

        <div className="oathbound-book-stage">
          <img
            className="oathbound-book"
            src="/media/images/Oath_book_3d.avif"
            alt="Three-dimensional view of The Oath of the Unhuan premium hardcover book"
            loading="eager"
            fetchpriority="high"
          />
        </div>

        <div className="oathbound-offer">
          <div
            className="oathbound-price"
            aria-label="Price ₹699 plus ₹50 handling and shipping"
          >
            <p className="oathbound-price-main">
              <span className="oathbound-currency" aria-hidden="true">
                ₹
              </span>
              <span>699</span>
            </p>
            <p className="oathbound-shipping">
              <span aria-hidden="true">+</span> ₹50 handling &amp; shipping
            </p>
          </div>

          <ul className="oathbound-features">
            {editionFeatures.map(({ label, Icon }) => (
              <li key={label}>
                <span className="oathbound-feature-icon" aria-hidden="true">
                  <Icon strokeWidth={1.55} />
                </span>
                <span>{label}</span>
              </li>
            ))}
          </ul>

          <SpecularButton
            className="oathbound-purchase-cta"
            onClick={() => navigate("/purchase")}
          >
            Buy Now
          </SpecularButton>
        </div>
      </section>

      <OathboundExplore />
      <OathboundReviews />
      <OathboundPublications />
    </main>
  );
}
